<template>
  <div class="company">
    <div class="header">
      <!-- 怎么将公司产品按钮定义成公司内部人员可点击 -->
      <span class="productBtn" v-if="is_staff" @click="toProducltView()">公司产品</span>
      <span class="createBtn" @click="showShadowView()">创建公司</span>
    </div>
    <div class="items">
      <!-- 我的公司 -->
      <div class="item" v-if="myCompany" @click="goDetailPage(myCompany)">
        <div class="logo">
          <img :src="myCompany.logo" />
        </div>
        <div class="rightView">
          <span class="title">{{myCompany.name}}</span>
          <p class="content">{{myCompany.content}}</p>
          <p class="desc">
            <span class="position tab">
              <img class="icon" :src="images.ceo" />
              <span class="text">{{myCompany.owner.name}}</span>
            </span>
            <span class="product tab">
              <img class="icon" :src="images.product" />
              <span class="text">{{myCompany.product_count}}个产品</span>
            </span>
            <span class="income tab">
              <img class="icon" :src="images.income" />
              <span class="text">{{myCompany.exist_income}}蓝钻</span>
            </span>
            <span class="member tab">
              <img class="icon" :src="images.member" />
              <span class="text">{{myCompany.member_count}}人</span>
            </span>
          </p>
        </div>
      </div>
      <div class="companyItem" v-for="item in data" :key="item.id">
        <div class="head">
          <div class="left">
            <span class="icon">
              <img :src="item.image" alt="图片加载失败" />
            </span>
            <span class="text">{{item.name}}</span>
          </div>
          <div class="footer" @click="goCompanyPage(item.id)">
            <span class="text">更多》</span>
          </div>
        </div>
        <div class="item_container" v-for="companyItem in item.top_2_company" :key="companyItem.pk">
          <CompanyGradeItem :dic="companyItem" />
        </div>
      </div>
    </div>
    <CreateCompany ref="createCompany" tag="shadow">
      <CreateCompany />
    </CreateCompany>
  </div>
</template>

<script>
// @ is an alias to /src
import CreateCompany from "./CreateCompany";
import CompanyGradeItem from "./CompanyGradeItem";

import { Utils } from "../utils";
import {
  IMG_COMPANY_CEO_ICON,
  IMG_COMPANY_PRODUCT_ICON,
  IMG_COMPANY_INCOME_ICON,
  IMG_COMPANY_MEMBER_ICON
} from "../assets";

import { types as LoginTypes } from "@/store/modules/login";
import { types as CompanyTypes } from "@/store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CompanyList",
  components: {
    CreateCompany,
    CompanyGradeItem
  },
  props: {},
  data() {
    return {
      images: {
        ceo: IMG_COMPANY_CEO_ICON,
        product: IMG_COMPANY_PRODUCT_ICON,
        income: IMG_COMPANY_INCOME_ICON,
        member: IMG_COMPANY_MEMBER_ICON
      },
      is_staff: false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      page: state => state.company.company.page,
      load_more: state => state.company.company.load_more,
      data: state => state.company.company_list.data,
      myCompany: state => state.company.myCompany
    })
  },
  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchListCompany: CompanyTypes.FETCH_LIST_COMPANY_DATA,
      fetchMyCompany: CompanyTypes.FETCH_MY_COMPANY
    }),
    ...Utils,

    showShadowView() {
      let callback = () => {
        this.$refs.createCompany.showShadowView();
      };
      this.dependLoginStatus().then(callback);
    },
    // 进入某一等级数据页面
    goCompanyPage(id) {
      this.$router.push(`/company/type/${id}`);
    },
    // 进入详情页
    goDetailPage(item) {
      this.$router.push(`/company/${item.pk}`);
    },
    // 进入公司全部产品页，内部人员按钮
    toProducltView() {
      this.$router.push("/company_product/detail");
    }
  },
  mounted() {
    this.fetchListCompany();
    // 还没有公司弹窗
    // this.dependLoginStatus("no_toast").then(() => {
    //   this.fetchMyCompany();
    // });
    let ownerInfo = localStorage.getItem('ownerInfo')
    ownerInfo = JSON.parse(ownerInfo)
    this.is_staff = ownerInfo["is_staff"]
  }
};
</script>

<style lang="less" scoped>
.company {
  width: 100%;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 10px;
    .productBtn {
      padding: 5px 15px;
      background-color: #ff7b00;
      border-radius: 15px;
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
      margin-right: 10px;
    }
    .createBtn {
      padding: 5px 15px;
      background-color: #ff7b00;
      border-radius: 15px;
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .items {
    .item {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      margin: 15px;
      margin-bottom: 25px;
      align-items: center;
      .logo {
        width: 100px;
        height: 100px;
        margin-right: 15px;
        border-radius: 8px;
        background-color: #f4f3f3;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
      .rightView {
        flex: 1;
        // height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          color: #333333;
          font-size: 15px;
          margin-bottom: 5px;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
        }
        .content {
          color: #666666;
          font-size: 13px;
          line-height: 23px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 5px;
          // height: 50px;
        }
        .desc {
          display: flex;
          flex-direction: row;
          color: #999999;
          font-size: 13px;
          overflow: hidden;
          height: 20px;
          line-height: 20px;
          .tab {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 20px;
            &.position {
              // flex: 1;
              max-width: 150px;
            }
            .icon {
              // width: 12px;
              height: 15px;
              margin-right: 5px;
            }
            .text {
              color: #999999;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
            }
          }
        }
      }
    }

    //等级公司列表
    .companyItem {
      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 40px 0 10px 0;
        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 15px;
          // margin-bottom: 10px;
          .icon {
            width: 30px;
          }
          .text {
            color: #333333;
            margin-left: 10px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
      .footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-right: 10px;
        .text {
          color: #6b45e1;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
